import { addTransitionForCssProperties, createStyles } from '@affstore-ds/uikit'

import { DATA_TRANSLATION_ATTRIBUTE } from '../constants'

export const useHtmlStyles = createStyles((theme) => ({
  html: {
    [`& [data-translation="${DATA_TRANSLATION_ATTRIBUTE}"]`]: {
      '& *': {
        color: theme.other.colors.greyIron[16],
        font: theme.other.fonts.desktop.s.s.default,
      },
      '& a': {
        '&::selection': {
          backgroundColor: theme.other.colors.blue[2],
        },
        '&:active': {
          color: theme.other.colors.blue[15],
          textDecorationColor: theme.other.colors.blue[15],
        },
        '&:hover': {
          color: theme.other.colors.blue[13],
          textDecorationColor: theme.other.colors.blue[13],
        },
        '&:visited': {
          '&:active': {
            color: theme.other.colors.blue[17],
            textDecorationColor: theme.other.colors.blue[17],
          },
          '&:hover': {
            textDecorationColor: theme.other.colors.blue[15],
          },

          color: theme.other.colors.blue[15],

          textDecorationColor: theme.other.colors.blue[15],
        },
        color: theme.other.colors.blue[13],

        textDecoration: 'underline',

        textDecorationColor: theme.other.colors.blue[9],

        textUnderlineOffset: 4,

        transition: addTransitionForCssProperties(['color', 'text-decoration-color']),
      },

      '& b': {
        color: theme.other.colors.greyIron[16],
        font: theme.other.fonts.desktop.s.s.header,
      },

      '& h1, h2, h3, h4, h5, h6': {
        marginBlock: 0,
      },
      '& h3, & h3 > span': {
        color: theme.other.colors.greyIron[18],
        font: theme.other.fonts.desktop.s.m.header,
        fontWeight: 500,
      },
      '& p': {
        margin: 0,
        marginBottom: 8,
        padding: 0,
      },
      '& table': {
        borderCollapse: 'collapse',
      },
      '& table, th, td': {
        border: '1px solid',
      },
      '& td': {
        padding: '4px',
      },
      '& ul': {
        '& li': {
          '&::marker': {
            fontSize: 18,
          },
          '&:first-of-type': {
            marginTop: 0,
          },

          marginTop: 4,
          paddingLeft: 8,
        },

        paddingLeft: 30,
      },
      color: theme.other.colors.greyIron[16],
      font: theme.other.fonts.desktop.s.s.default,
    },
  },
}))
